<h2 mat-dialog-title>Manual payment</h2>

<mat-dialog-content>
  <p class="hint">
    For a payment that is not for any transfer run or contract — a bonus, or fixing a mistake.
    It is only recorded here.
  </p>

  <div class="field"><app-supplier-filter [supplierId]="supplierId" (supplierIdChange)="supplierId = $event"></app-supplier-filter></div>

  <div class="row">
    <mat-form-field appearance="outline" class="kind">
      <mat-label>Type</mat-label>
      <mat-select [(ngModel)]="kind">
        <mat-option value="Bonus">Bonus</mat-option>
        <mat-option value="Correction">Correction (fixing a mistake)</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="amount">
      <mat-label>Amount (Toman)</mat-label>
      <input matInput type="number" min="1" step="1" [(ngModel)]="amount">
    </mat-form-field>
  </div>

  <mat-form-field appearance="outline" class="full">
    <mat-label>Description</mat-label>
    <textarea matInput rows="3" required [maxlength]="maxNoteLength" [(ngModel)]="note"
      placeholder="What is this payment for? The supplier and your accountant will read this."></textarea>
    <mat-hint align="end">{{ note.length }} / {{ maxNoteLength }}</mat-hint>
  </mat-form-field>

  <div class="file-row">
    <button mat-stroked-button type="button" [disabled]="proofFiles.length >= maxProofs" (click)="fileInput.click()">
      <mat-icon>attach_file</mat-icon> Attach payment proof
    </button>
    <input #fileInput type="file" [accept]="accept" multiple hidden (change)="onFilesSelected($event)">
  </div>
  @for (f of proofFiles; track $index; let i = $index) {
  <div class="file-row">
    <span class="file-name">{{ f.name }}</span>
    <button mat-icon-button type="button" (click)="removeFile(i)"><mat-icon>close</mat-icon></button>
  </div>
  }
  @if (fileError) { <p class="error">{{ fileError }}</p> }
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button type="button" (click)="dialogRef.close(null)">Cancel</button>
  <button mat-flat-button color="primary" type="button" [disabled]="!valid || saving" (click)="submit()">
    Record payment
  </button>
</mat-dialog-actions>
